import React from "react";
import { Link } from "react-router-dom";
import founderImageSumit from "../images/sumit.jpg"; // Image for Sumit Aggarwal
import founderImageAgam from "../images/agam.jpg"; // Image for Agam Garg - Ensure this exists
import haridwarImage from "../images/haridwar.jpeg";

const Home = () => {
  const containerStyle = {
    textAlign: "center",
    padding: "clamp(10px, 5vw, 20px)",
    maxWidth: "800px",
    margin: "0 auto",
  };

  const imageStyle = {
    width: "100%",
    maxWidth: "400px",
    maxHeight: "400px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    height: "auto",
  };

  const buttonStyle = {
    padding: "clamp(8px, 2vw, 10px) clamp(15px, 3vw, 20px)",
    fontSize: "clamp(14px, 2.5vw, 16px)",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    cursor: "pointer",
    marginTop: "10px",
  };

  const flexContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
    margin: "20px 0",
  };

  const tourCardStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    width: "100%",
    maxWidth: "200px",
  };

  const founderContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "30px",
    margin: "20px 0",
  };

  const founderCardStyle = {
    flex: "1 1 300px",
    maxWidth: "350px",
    textAlign: "center",
  };

  const founderImageStyle = {
    width: "clamp(100px, 30vw, 150px)",
    height: "clamp(100px, 30vw, 150px)",
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #007BFF",
    marginBottom: "15px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  };

  const mapLinkStyle = {
    color: "#007BFF",
    textDecoration: "none",
    fontWeight: "bold",
  };

  return (
    <div style={containerStyle}>
      <h1>Welcome to Chaar Dham Yatra Cabs, Uttarakhand</h1>
      <p>Your trusted travel partner for Char Dham Yatra & city tours</p>
      
      <div style={{ margin: "20px 0" }}>
        <img
          src={haridwarImage}
          alt="Tour Image"
          style={imageStyle}
        />
      </div>

      <Link to="/tours">
        <button style={buttonStyle}>Book Your Tour Now!</button>
      </Link>

      <div style={{ marginTop: "20px" }}>
        <h2>Featured Tours</h2>
        <div style={flexContainerStyle}>
          <div style={tourCardStyle}>
            <h3>Char Dham Yatra</h3>
            <p>₹45,000 - 9 Days</p>
          </div>
          <div style={tourCardStyle}>
            <h3>Rishikesh Adventure</h3>
            <p>₹6,000 - 2 Days</p>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <h2>About Our Founders</h2>
        <div style={founderContainerStyle}>
          {/* Founder 1: Sumit Aggarwal */}
          {/* <div style={founderCardStyle}>
            <img src={founderImageSumit} alt="Mr. Sumit Aggarwal" style={founderImageStyle} />
            <p>
              Meet <strong>Mr. Sumit Aggarwal</strong>, one of the founders of Haridwar Tours. With over 15 years of experience in the travel and hospitality industry, Sumit is dedicated to making your spiritual and adventure journeys unforgettable.
            </p>
          </div> */}

          {/* Founder 2: Agam Garg */}
          <div style={founderCardStyle}>
            <img src={founderImageAgam} alt="Mr. Agam Garg" style={founderImageStyle} />
            <p>
              Meet <strong>Mr. Agam Garg</strong>, one of the founders of Haridwar Tours. A Chartered Accountant by profession with extensive experience in hospitality and finance, Agam ensures seamless operations and exceptional value for every traveler.
            </p>
          </div>
        </div>

        <h3>Stay at Our Hotel</h3>
        <p>
          Visit <strong>Aggarwal Dhaam</strong>, our family-run hotel located at:
          <br />
          <em>Bairagi camp, Kankhal, Haridwar, Uttarakhand 249408</em>
          <br />
          Enjoy comfortable stays with stunning views of the Ganges!
          <br />
          <a
            href="https://www.google.com/maps/place/Aggarwal+Dham/data=!4m2!3m1!1s0x0:0x4a4e014e9fd13691?sa=X&ved=1t:2428&ictx=111"
            target="_blank"
            rel="noopener noreferrer"
            style={mapLinkStyle}
          >
            View on Google Maps
          </a>
        </p>
      </div>

      <div style={{ marginTop: "20px" }}>
        <h2>What Our Travelers Say</h2>
        <blockquote style={{ fontStyle: "italic", margin: "10px 0" }}>
          "An amazing experience! The Char Dham Yatra was seamless and spiritual." – Priya K.
        </blockquote>
        <blockquote style={{ fontStyle: "italic", margin: "10px 0" }}>
          "Loved the stay at Aggarwal Dhaam and the tour guidance!" – Anil S.
        </blockquote>
      </div>
    </div>
  );
};

export default Home;